import { render, staticRenderFns } from "./objective-setup.vue?vue&type=template&id=14845bb6&"
import script from "./objective-setup.vue?vue&type=script&lang=ts&"
export * from "./objective-setup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports